import AccordionDisplay from './AccordionDisplay_v2';

export default AccordionDisplay;
